// extracted by mini-css-extract-plugin
export default {"page":"Page_page__tXzm8Bu1","title":"Page_title__wJIvJir5"};